import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

// Staff-only triage flag over the existing PATCH /enquiries/{id}/missing-info. Notes are internal and never reach the client projection.
export function AwaitingInfoPanel({ enquiry, onChanged, disabled }) {
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);
  const set = async (awaiting) => {
    setBusy(true);
    try {
      await api.patch(`/enquiries/${enquiry.id}/missing-info`, { awaiting, notes: awaiting ? notes || null : null });
      toast.success(awaiting ? "Marked as awaiting information" : "Awaiting-information flag cleared");
      setNotes("");
      onChanged();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not update the flag"); } finally { setBusy(false); }
  };
  return (
    <Card data-testid="awaiting-info-panel" className={enquiry.awaiting_info ? "border-jigsaw-warning/50" : "border-jigsaw-border"}>
      <CardHeader className="flex flex-row items-center justify-between gap-3">
        <CardTitle className="text-base text-jigsaw-navy">Awaiting information</CardTitle>
        <span data-testid="awaiting-info-state" className={`rounded-full border px-2.5 py-0.5 text-[12px] font-medium ${enquiry.awaiting_info ? "border-jigsaw-warning/30 bg-jigsaw-warningBg text-jigsaw-warning" : "border-jigsaw-border text-jigsaw-muted"}`}>{enquiry.awaiting_info ? "Awaiting information" : "Not flagged"}</span>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-[12px] text-jigsaw-muted">Internal triage flag. Notes are visible to Jigsaw staff only and are never shown to the client.</p>
        {enquiry.awaiting_info ? (
          <>
            {enquiry.awaiting_info_notes && <p data-testid="awaiting-info-notes" className="rounded-md bg-jigsaw-bg px-3 py-2 text-sm text-jigsaw-navy">{enquiry.awaiting_info_notes}</p>}
            <Button data-testid="awaiting-info-clear-button" size="sm" variant="outline" disabled={busy || disabled} onClick={() => set(false)}>Clear flag</Button>
          </>
        ) : (
          <>
            <div><Label htmlFor="awaiting-info-notes-input">Internal notes (optional)</Label><Textarea id="awaiting-info-notes-input" data-testid="awaiting-info-notes-input" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="What is missing and who was asked" /></div>
            <Button data-testid="awaiting-info-mark-button" size="sm" disabled={busy || disabled} onClick={() => set(true)}>Mark as awaiting information</Button>
          </>
        )}
      </CardContent>
    </Card>
  );
}
